import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { AsyncPipe } from '@angular/common';
import { CartePrestationComponent } from "../carte-prestation/carte-prestation.component";
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-presentation-prestations',
  imports: [AsyncPipe, CartePrestationComponent, RouterLink],
  templateUrl: './presentation-prestations.component.html',
  styleUrl: './presentation-prestations.component.scss'
})
export class PresentationPrestationsComponent {
  private apiService: ApiService = inject(ApiService);
  public $typesDePrestations: Observable<any[]> = this.apiService.getTypesDePrestations();
}
